module.exports = __webpack_public_path__ + "img/lens-collection-contact-lens-coverage.d62d261d.jpg";